import { Domains } from 'monitoring/constants/domains'
import { Types } from 'monitoring/constants/types'
import { useLog } from 'monitoring/sendLog/client/useLog'
import { RETURNS_BASE_URL } from 'my-purchases/constants/endpoints'
import { useFetch } from 'my-purchases/hooks/useFetch/useFetch'
import { downloadPdf } from 'my-purchases/utils/downloadPdf'
import { useSession } from 'session/src/hooks/useSession'
import { url } from 'utils/url'
import { useGuestEmail } from 'utils/useGuestEmail/useGuestEmail'

export const useDownloadReturnsPdf = () => {
	const { fetcher } = useFetch()
	const { logged } = useSession()
	const guestEmail = useGuestEmail()
	const { sendLog } = useLog()
	const isGuestUser = !logged && guestEmail

	const downloadReturnsPdf = async ({
		path,
		billingEmail,
		pdfName,
	}: {
		path: string
		billingEmail?: string
		pdfName: string
	}) => {
		const queryParams = billingEmail ? `?email=${billingEmail}` : ''

		try {
			const response = await fetcher<Blob>({
				url: url(`${RETURNS_BASE_URL}/${path}${queryParams}`),
				...(isGuestUser && { extraHeaders: { 'x-guest-email': guestEmail } }),
				isBlob: true,
			})

			if (!response?.resolveData) {
				throw Error('No data to download')
			}

			downloadPdf(response.resolveData, pdfName)
		} catch (e) {
			sendLog({
				message: '[My Purchases] Error downloading returns pdf',
				type: Types.Error,
				domain: Domains.MyPurchases,
			})
		}
	}

	return { downloadReturnsPdf }
}
